// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getPartDetails} from '../../shared/repositories';

export const readPartDetails = (partNumber, index) =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const partDetails = await getPartDetails(partNumber);

            dispatch({
                index,
                partDetails,
                type: actions.SET_CLAIM_PARTS_PART_DETAILS
            });

            dispatch({
                partDetails,
                type: actions.UPDATE_CLAIM_PART_DETAILS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/parts/action-creators/get-part-details.js